const state = {
  pet: {},
  petHospital: {},
  vaccineInfo:{},
  recordDate:''
}

const mutations = {
  SET_PETNAME: (state, pet) => {
    state.pet = pet
  },
  SET_PETHOSPITAL: (state, hospital) => {
    state.petHospital = hospital
  },
  SET_VACCINEINFO: (state, vaccine) => {
    sessionStorage.setItem('vaccineInfo', JSON.stringify(vaccine))
    state.vaccineInfo = vaccine
  },
  SET_RECORDDATE: (state, time) => {
    state.recordDate = time
  }
}

const actions = {
 
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
